import {dispatch} from 'd3-dispatch';
import RectLinear from '../rectLinear';
import brushableMixin from '../brushable/';
import seriesableMixin from '../seriesable/';
import zoomableMixin from '../zoomable/';
import {mixedMeasure} from '../default/';
import {className, setMethodsFromAttrs, setMethodFromDefaultObj} from '../../modules/util';
import _brush from './_brush';
import _brushZoom from './_brushZoom';
import _mark from './_mark';
import _munge from './_munge';
import _scale from './_scale';
import _axis from './_axis';
import _meanLine from './_meanLine';
import _legend from './_legend';
import _region from './_region';
import _facet from './_facet';
import _tooltip from './_tooltip';
import _zoom from './_zoom';

const curves = ['linear', 'stepped', 'curved'];
const size = {range: [2, 2], scale: 'linear', reverse: false};
const shapes = ['line', 'area'];
const conditions = ['normal', 'count', 'mixed'];
const _attrs = {
  curve: curves[0],
  facet: false,
  meanLine : false,
  multiTooltip: false,
  normalized: false,
  padding: 0,
  point: false,
  pointRatio : 2,
  regionPadding: 0.1,
  shape: shapes[0],
  scaleBandMode : false,
  size: size,
  stacked: false,
  individualScale: false // 멀티 시리즈 일때 시리즈 별로 별도의 스케일 갖는다.
};

class Line extends seriesableMixin(brushableMixin(zoomableMixin(RectLinear))) {
  constructor() {
    super(_attrs);
    this.__execs__.dispatch = dispatch('start', 'move', 'end');
    this.rebindOnMethod(this.__execs__.dispatch);
  }
}

function _line() {
  let line =  new Line();
  return line;
}

function update() {
 // 데이터가 바뀐 경우

 // 데이터의 계산에 영향 주는 요소가 바뀐 경우

 // 다른 화면 요소가 바뀐 경우 
}

function measureName() {
  let measures = this.measures();
  let yField;
  if (this.condition() === conditions[2]) yField = mixedMeasure.field; 
  else if (this.aggregated() && measures[0].field === mixedMeasure.field) yField = measures[0].field;
  else yField = measures[0].field + '-' + measures[0].op;
  return yField;
}

function isCount() {
  return this.condition() === conditions[1];
}

function isFacet() {
  return this.facet() && this.isNested() && !this.stacked();
}

function isIndividualScale() {
  return this.isNested() && !this.stacked() && this.individualScale();
}
function isMixed() {
  return this.condition() == conditions[2] ;
}

function isNested() {
  let dimensions = this.dimensions();
  let condition = this.condition();
  return dimensions.length === 2 || (condition == conditions[2] && dimensions.length === 1);
}

function isStacked() {
  return this.stacked() && this.isNested();
} 

function highlight(selection, highlightColor) {
  selection.select('path' + className('line', true)).style('stroke', highlightColor);
  selection.select('path' + className('area', true)).style('fill', highlightColor);
  selection.select('circle').style('stroke', highlightColor);
}

function highlightFromLegend(legend) {
  this.highlightRegions(d => d.data.key === legend.key);
}

function highlightToLegend(d) {
  const legend = this.__execs__.legend;
  legend.highlight(d.parent.data.key);
}

function dehighlight(selection) {
  const f = d => d.color;
  selection.select('path' + className('line', true)).style('stroke', f);
  selection.select('path' + className('area', true)).style('fill', f);
  selection.select('circle').style('stroke', f);
}

function dehighlightFromLegend(legend) {
  this.dehighlightRegions(d => d.data.key === legend.key);
}

function dehighlightToLegend(d) {
  const legend = this.__execs__.legend;
  legend.dehighlight(d.parent.data.key);
}

function tick(tick, start) { //facet 상태에서 multitooltip 활용시 사용
  if (this.multiTooltip() && this.parent()) {
    let mt = this.__execs__.tooltip;
    mt.tick(tick, start);
  }
}

function renderLayout() {
  this.reset();
  this.renderFrame();
  _munge.call(this);
  if (this.isBrushZoom()) {
    this.noAxisOffset(true);
    this.renderCanvas();
    _brushZoom.call(this);
    return; 
  }
  _scale.call(this);
  this.renderCanvas(this.point() ? this.size().range[0]*2 : 0);
  _axis.call(this);
  _region.call(this);
  if (this.isFacet()) {
    _facet.call(this);
  } else {
    _mark.call(this);
  }
  _meanLine.call(this);
  _tooltip.call(this);
  _zoom.call(this);
  _brush.call(this);
  _legend.call(this);
}

setMethodFromDefaultObj(Line, 'multiTooltip', {sortByValue: 'natural'});
Line.prototype.measureName = measureName; //OVERRIDE: measure로 사용되는 필드 이름 자동 생성 
Line.prototype.renderLayout = renderLayout;
Line.prototype.update = update;
Line.prototype.isCount = isCount;
Line.prototype.isFacet = isFacet;
Line.prototype.isIndividualScale = isIndividualScale;
Line.prototype.isMixed = isMixed;
Line.prototype.isNested = isNested;
Line.prototype.isStacked = isStacked;
Line.prototype.highlight = highlight;
Line.prototype.highlightFromLegend = highlightFromLegend;
Line.prototype.highlightToLegend = highlightToLegend;
Line.prototype.dehighlight = dehighlight;
Line.prototype.dehighlightFromLegend = dehighlightFromLegend;
Line.prototype.dehighlightToLegend = dehighlightToLegend;
Line.prototype.tick = tick;
setMethodsFromAttrs(Line, _attrs);

export default _line;
export {conditions, curves, shapes};



// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/line/index.js